import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Container, Grid, Typography, Box, CircularProgress } from '@mui/material';
import ProductList from '../components/ProductList';

const API_URL = 'https://zebrastore-api.onrender.com/api';

function SearchResults() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();


  useEffect(() => {
    const fetchSearchResults = async () => {
      setLoading(true);
      const query = new URLSearchParams(location.search).get('q') || '';

      try {
        const response = await axios.get(`${API_URL}/search?q=${encodeURIComponent(query)}`);
        setProducts(response.data.products || []);
      } catch (err) {
        setError('Failed to load search results');
      } finally {
        setLoading(false);
      }
    };

    fetchSearchResults();
  }, [location.search]);

  const query = new URLSearchParams(location.search).get('q') || '';

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Search Results for "{query}"
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : products.length === 0 ? (
        <Typography>No products found matching your search.</Typography>
      ) : (
        <ProductList products={products} />
      )}
    </Container>
  );
}

export default SearchResults;